import type { HTMLAttributes } from "react";

export function GlassCard({
  className = "",
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`glass rounded-[var(--radius-lg)] p-6 shadow-[var(--shadow-glass)] transition-[background,border-color,box-shadow] duration-200 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
